import { object, string, array, number } from 'yup';
import { ValidationSchema } from 'enums/CreateProductModalEnums';

interface PackageFieldInterface {
  name: string;
  placeholder: string;
  label: string;
  size: string;
  select: boolean;
  option?: optionsInterface[];
}
interface optionsInterface {
  id: number;
  label: string;
}
interface unitOptionsInterface {
  id: number;
  value: string;
}

export const bestFitRegion: optionsInterface[] = [
  {
    id: 1,
    label: 'Toronto',
  },
  {
    id: 2,
    label: 'Quebec',
  },
  {
    id: 3,
    label: 'London',
  },
];
export const unitOptions: unitOptionsInterface[] = [
  {
    id: 1,
    value: 'g',
  },
  {
    id: 2,
    value: 'kg',
  },
  {
    id: 3,
    value: 'ml',
  },
  {
    id: 4,
    value: 'L',
  },
];

export const packagingUnitOptions: unitOptionsInterface[] = [
  {
    id: 1,
    value: 'g',
  },
  {
    id: 2,
    value: 'kg',
  },
];

export const initialValues = {
  ingredients: {
    ingredientName: undefined,
    ingredientOrigin: undefined,
    bestFitProductionRegion: undefined,
    ingredientQuantity: '',
    ingredientUnit: undefined,
  },

  packingMaterial: {
    packingMaterialName: undefined,
    packingMaterialOrigin: undefined,
    packingMaterialbestFitProductionRegion: undefined,
    packingMaterialQuantity: '',
    packingMaterialUnit: undefined,
    numberofUnitsPerPackingMaterial: '',
  },
};

const ingredientSchema = object().shape({
  ingredientName: string().required(ValidationSchema.ERROR_MESSAGE),
  ingredientOrigin: string().when('origins', {
    is: origins => origins.length === 0,
    then: string().required(ValidationSchema.ERROR_MESSAGE),
    otherwise: string(),
  }),
  bestFitProductionRegion: string().when('origins', {
    is: origins => origins.length === 0,
    then: string().required(ValidationSchema.ERROR_MESSAGE),
    otherwise: string(),
  }),
  ingredientQuantity: number()
    .typeError(ValidationSchema.NUMBER)
    .required(ValidationSchema.ERROR_MESSAGE)
    .test('is-decimal', 'Please enter only 2 decimal values', value => {
      return (
        value === undefined ||
        value === null ||
        /^\d+(\.\d{1,2})?$/.test(value.toString())
      );
    }),
  ingredientUnit: string().required(ValidationSchema.ERROR_MESSAGE),
  origins: array().of(
    object().shape({
      ingredientOrigin: string().required('Origin ingredient is required'),
      bestfitRegion: string().required('Best fit region is required'),
      originShare: number()
        .required('Origin Share is required')
        .min(0, 'Origin Share must be at least 0')
        .max(100, 'Origin Share cannot be more than 100')
        .test('is-decimal', 'Please enter only 2 decimal values', value => {
          if (value !== undefined && value !== null) {
            return /^\d+(\.\d{1,2})?$/.test(value.toString());
          }
          return true;
        }),
    })
  ),
});

const packageMaterialSchema = object().shape({
  packingMaterialName: string().required(ValidationSchema.ERROR_MESSAGE),
  packingMaterialOrigin: string().when('origins', {
    is: origins => origins.length === 0,
    then: string().required(ValidationSchema.ERROR_MESSAGE),
    otherwise: string(),
  }),
  packingMaterialbestFitProductionRegion: string().when('origins', {
    is: origins => origins.length === 0,
    then: string().required(ValidationSchema.ERROR_MESSAGE),
    otherwise: string(),
  }),
  packingMaterialQuantity: number()
    .typeError(ValidationSchema.NUMBER)
    .required(ValidationSchema.ERROR_MESSAGE)
    .test('is-decimal', 'Please enter only 2 decimal values', value => {
      return (
        value === undefined ||
        value === null ||
        /^\d+(\.\d{1,2})?$/.test(value.toString())
      );
    }),
  packingMaterialUnit: string().required(ValidationSchema.ERROR_MESSAGE),
  numberOfUnitsPerPackingMaterial: number()
    .typeError(ValidationSchema.NUMBER)
    .moreThan(0, ValidationSchema.MIN)
    .required(ValidationSchema.ERROR_MESSAGE),
  origins: array().of(
    object().shape({
      ingredientOrigin: string().required('Origin ingredient is required'),
      bestfitRegion: string().required('Best fit region is required'),
      originShare: number()
        .required('Origin Share is required')
        .min(0, 'Origin Share must be at least 0')
        .max(100, 'Origin Share cannot be more than 100')
        .test('is-decimal', 'Please enter only 2 decimal values', value => {
          if (value !== undefined && value !== null) {
            return /^\d+(\.\d{1,2})?$/.test(value.toString());
          }
          return true;
        }),
    })
  ),
});

export const validationSchema = object({
  ingredients: array().of(ingredientSchema),
  packageMaterials: array().of(packageMaterialSchema),
});

export const RAW_MATERIAL_CONSTANTS = {
  INPUT_FIELD: 'input_field',
  QUANTITY: 'quantity',
  PRODUCTION_REGION: 'production region',
  INGREDIENT_ORIGIN: 'ingredient origin',
  INGREDIENT_NAME: 'ingredient name',
  PACKAGE_MATERIAL_NAME: 'packaging material name',
  PACKAGE_MATERIAL_ORIGIN: 'packaging material origin',
  PACKAGE_MATERIAL_PRODUCTION_REGION: 'packaging material production region',
  PACKAGE_MATERIAL_WEIGHT: 'packaging material weight',
};
